import { Link, useParams } from 'react-router-dom';
import { categories, trendingArticles } from '@/mocks/articles';

export default function CategoryHero() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const count = trendingArticles.filter((a) => a.category === slug).length;

  if (!category) return null;

  return (
    <section className="relative w-full pt-24 pb-12 md:pt-28 md:pb-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Breadcrumb */}
        <nav aria-label="面包屑导航" className="mb-6">
          <ol className="flex items-center gap-2 text-sm text-foreground-400">
            <li>
              <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">
                首页
              </Link>
            </li>
            <li>
              <i className="ri-arrow-right-s-line text-xs"></i>
            </li>
            <li>
              <span className="text-foreground-700 font-medium">{category.name}</span>
            </li>
          </ol>
        </nav>

        {/* Category Header */}
        <div className="flex items-start gap-4 mb-3">
          <div className="w-12 h-12 md:w-14 md:h-14 bg-primary-500 rounded-xl flex items-center justify-center shrink-0">
            <i className={`${category.icon} text-background-50 text-xl md:text-2xl`}></i>
          </div>
          <div>
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              {category.name}
            </h1>
            <p className="text-foreground-500 text-sm mt-1">{category.description}</p>
          </div>
        </div>

        <div className="flex items-center gap-4 text-sm text-foreground-400">
          <span>共 <strong className="text-primary-500 font-semibold">{count}</strong> 篇爆料</span>
        </div>
      </div>
    </section>
  );
}

export function CategoryPageSEO({ slug }: { slug: string | undefined }) {
  const category = categories.find((c) => c.slug === slug);
  if (!category) return null;

  const canonicalUrl = `https://www.911baoliao.com/category/${slug}`;
  const seoData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首页',
            item: 'https://www.911baoliao.com/',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: category.name,
            item: canonicalUrl,
          },
        ],
      },
      {
        '@type': 'CollectionPage',
        name: `${category.name} - 911爆料网`,
        description: category.description,
        url: canonicalUrl,
        isPartOf: {
          '@type': 'WebSite',
          name: '911爆料网',
          url: 'https://www.911baoliao.com/',
        },
      },
    ],
  };

  return (
    <>
      <title>{category.name} - 911爆料网 | 网红黑料明星塌房每日吃瓜爆料</title>
      <meta name="description" content={`911爆料网${category.name}专区 - ${category.description}。每日更新最新${category.name}内容，追踪网红黑料、明星塌房、吃瓜爆料一手资讯。`} />
      <meta name="keywords" content={`${category.name},911爆料网,吃瓜爆料,网红黑料,明星塌房`} />
      <link rel="canonical" href={canonicalUrl} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(seoData) }} />
    </>
  );
}